var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGreenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dii_16703_1282)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 30.3819C8.75 21.0556 8.75 16.3925 9.85109 14.8237C10.9522 13.2549 15.3368 11.754 24.106 8.75231L25.7767 8.18042C30.3479 6.6157 32.6335 5.83333 35 5.83333C37.3666 5.83333 39.6521 6.6157 44.2233 8.18043L45.894 8.75231C54.6632 11.754 59.0478 13.2549 60.1489 14.8237C61.25 16.3925 61.25 21.0556 61.25 30.3819C61.25 31.7906 61.25 33.3183 61.25 34.9748C61.25 51.4192 48.8864 59.3993 41.1292 62.7879C39.025 63.7071 37.9728 64.1667 35 64.1667C32.0272 64.1667 30.975 63.7071 28.8708 62.7879C21.1136 59.3993 8.75 51.4192 8.75 34.9748C8.75 33.3183 8.75 31.7906 8.75 30.3819Z",
    fill: "#20BF86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 30.3819C8.75 21.0556 8.75 16.3925 9.85109 14.8237C10.9522 13.2549 15.3368 11.754 24.106 8.75231L25.7767 8.18042C30.3479 6.6157 32.6335 5.83333 35 5.83333C37.3666 5.83333 39.6521 6.6157 44.2233 8.18043L45.894 8.75231C54.6632 11.754 59.0478 13.2549 60.1489 14.8237C61.25 16.3925 61.25 21.0556 61.25 30.3819C61.25 31.7906 61.25 33.3183 61.25 34.9748C61.25 51.4192 48.8864 59.3993 41.1292 62.7879C39.025 63.7071 37.9728 64.1667 35 64.1667C32.0272 64.1667 30.975 63.7071 28.8708 62.7879C21.1136 59.3993 8.75 51.4192 8.75 34.9748C8.75 33.3183 8.75 31.7906 8.75 30.3819Z",
    stroke: "#3F3F3F"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.3332 28L31.4998 40.8333L25.6665 35",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dii_16703_1282",
    x: 4.75,
    y: 1.83333,
    width: 60.5,
    height: 66.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16703_1282"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16703_1282",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_16703_1282"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_16703_1282",
    result: "effect3_innerShadow_16703_1282"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreenIcon);
export default __webpack_public_path__ + "static/media/check-green-icon.49bf9b54854e6311742cf664cc451f51.svg";
export { ForwardRef as ReactComponent };